import React from 'react';
import PropTypes from 'prop-types';
import { BaseUserProfile } from 'fitbeat.models';

export const FeatureToggle = ({ releaseType, userProfile, condition, children }) =>
  BaseUserProfile.isFeatureEnabledForUser(releaseType, userProfile, condition) ? (
    <>{children}</>
  ): null;

FeatureToggle.propTypes = {
  releaseType: PropTypes.oneOf(['alpha', 'beta']).isRequired,
  userProfile: PropTypes.object.isRequired,
  condition: PropTypes.func,
};
